export const DEFAULT_CARD_COLOR = "#4f9fe0";
